import { DeleteCatalogProductsResponseSchema, type DeleteCatalogProductsResponse } from '@vy/api-definition';
import { useMutation, useQueryClient, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { DeleteCatalogProductsRequest } from '../../../../../libs/client/src/generated/apis/DefaultApi';
import { invalidateProductsQueries } from '../../utils/query-invalidation';

export function useDeleteCatalogProducts(
  options?: UseMutationOptions<DeleteCatalogProductsResponse, unknown, DeleteCatalogProductsRequest>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ catalogProductId }) => {
      const api = getPrivateApi();
      const deleteCatalogProductsResponse = await api.deleteCatalogProducts({ catalogProductId });

      return DeleteCatalogProductsResponseSchema.parse(deleteCatalogProductsResponse);
    },
    onSuccess: async () => {
      await invalidateProductsQueries(queryClient);
    },
    ...options,
  });
}
